import React from 'react';
import { motion } from 'framer-motion';
interface StickerProps {
  children: React.ReactNode;
  rotation?: number;
  className?: string;
}
export function Sticker({
  children,
  rotation = 6,
  className = ''
}: StickerProps) {
  return <motion.div whileHover={{
    scale: 1.1,
    rotate: rotation > 0 ? rotation + 5 : rotation - 5
  }} className={`absolute z-20 inline-flex items-center justify-center rounded-full border-4 border-otter-black bg-otter-cyan p-4 font-display text-otter-black shadow-brutal ${className}`} style={{
    transform: `rotate(${rotation}deg)`
  }} data-id="element-298">
      {children}
    </motion.div>;
}